export default type => !type.name.startsWith('__');